import Utils from "./utils";

class ItemsExport {
  constructor() {
    this.exportButton = document.querySelector('.js-clb-export-to-indesign');

    if (!this.exportButton) {
      return;
    }

    this.loading = false;
    this.items = [];
    this.listingItems = document.querySelectorAll('.js-clb-listing-item');

    if (!this.listingItems.length) {
      this.exportButton.remove();
      return;
    }

    this.exportHandler();
  }

  exportHandler() {
    this.exportButton.addEventListener('click', () => {
      if (this.loading) {
        return;
      }

      this.listingItems.forEach((item) => {
        const link  = item.querySelector('.js-clb-listing-item-inner').getAttribute('href');
        const title  = item.querySelector('.js-clb-listing-item-title').textContent;
        const price  = item.querySelector('.js-clb-listing-item-price').textContent;
        const type   = item.querySelector('.js-clb-listing-item-type').textContent;
        const imageUrl    = item.querySelector('.js-clb-listing-item-img').getAttribute('data-export-url');

        this.items.push({
          link,
          title,
          price,
          type,
          imageUrl,
        });
      });

      this.exportButton.classList.add('is-loading');

      Utils.ajaxRequest('km_clb_export_listings', {
        items: JSON.stringify(this.items),
      }).then((response) => {
        const link = document.createElement('a');
        link.href = response.exportUrl;
        link.click();

        this.exportButton.classList.remove('is-loading');
        this.loading = false;
      });

      this.loading = true;
    });
  }
}

export default ItemsExport;
